module.exports = require("@swa-ui/placements/src/PlacementFactory/ErrorPlacement/ErrorPlacement.module.scss");